import { render, staticRenderFns } from "./BgThumbnail.vue?vue&type=template&id=3cb6ca2c&scoped=true&"
import script from "./BgThumbnail.vue?vue&type=script&lang=js&"
export * from "./BgThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./BgThumbnail.vue?vue&type=style&index=0&id=3cb6ca2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb6ca2c",
  null
  
)

export default component.exports